import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import styles from "../../css/EditForm.module.css";

const EditJob = () => {
  // Get jobId from URL parameters
  const { jobId } = useParams();

  // Define state variables for each job attribute
  const [title, setTitle] = useState("");
  const [company, setCompany] = useState("");
  const [location, setLocation] = useState("");
  const [description, setDescription] = useState(""); // Job description
  const [requirements, setRequirements] = useState(""); // Requirements as a comma-separated string
  const [salary, setSalary] = useState(""); // Optional salary field
  const [jobType, setJobType] = useState("");
  const navigate = useNavigate();

  // Fetch job details on initial render
  useEffect(() => {
    fetchJobDetails();
  }, []);

  // Fetch job details using jobId, pre-fill form fields
  const fetchJobDetails = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        alert("You need to log in first.");
        navigate("/university/login");
        return;
      }

      // Get the job data from backend using jobId
      const response = await axios.get(
        `https://techservicemarket-backend.onrender.com/api/universitypartner/jobs/${jobId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Add token to headers for authorization
          },
        }
      );

      // Populate form fields with fetched data
      const job = response.data;
      setTitle(job.title);
      setCompany(job.company);
      setLocation(job.location);
      setDescription(job.description);
      setRequirements(job.requirements.join(", ")); // Convert array to comma-separated string
      setSalary(job.salary);
      setJobType(job.jobType);
    } catch (error) {
      console.error("Error fetching job details:", error);
      alert("Failed to fetch job details. Please try again.");
    }
  };

  // Update job with form data when submitted
  const handleUpdateJob = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        alert("You need to log in first.");
        navigate("/university/login");
        return;
      }

      // Build updated job object from form fields
      const updatedJob = {
        title,
        company,
        location,
        description,
        requirements: requirements.split(",").map((req) => req.trim()), // Convert comma-separated string to array
        salary,
        jobType,
      };

      // Send updated job data to backend
      await axios.put(
        `https://techservicemarket-backend.onrender.com/api/universitypartner/jobs/${jobId}`,
        updatedJob,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include token in authorization headers
          },
        }
      );

      alert("Job updated successfully"); // Show success message
      navigate("/university/jobs/reposted"); // Redirect to reposted jobs page after update
    } catch (error) {
      console.error("Error updating job:", error);
      alert("Failed to update the job. Please try again.");
    }
  };

  return (
    <div className={styles.jobFormContainer}>
      {/* Back to Dashboard Button */}
      <button
        className={styles.backButton}
        onClick={() => navigate("/university/jobs/reposted")}
      >
        ← Back to Jobs
      </button>

      {/* Edit Job Form */}
      <h2>Edit Job</h2>
      <div className={styles.mainContent}>
      <input
        type="text"
        placeholder="Job Title"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        className={styles.inputField}
      />
      <input
        type="text"
        placeholder="Company Name"
        value={company}
        onChange={(e) => setCompany(e.target.value)}
        className={styles.inputField}
      />
      <input
        type="text"
        placeholder="Location"
        value={location}
        onChange={(e) => setLocation(e.target.value)}
        className={styles.inputField}
      />
      <textarea
        placeholder="Job Description"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        className={styles.textareaField} // Styling for a larger text area
      />
      <input
        type="text"
        placeholder="Requirements (comma-separated)"
        value={requirements}
        onChange={(e) => setRequirements(e.target.value)}
        className={styles.inputField}
      />
      <input
        type="number"
        placeholder="Salary (optional)"
        value={salary}
        onChange={(e) => setSalary(e.target.value)}
        className={styles.inputField}
      />
      <select
        value={jobType}
        onChange={(e) => setJobType(e.target.value)}
        className={styles.selectInput}
      >
        <option value="">Select Job Type</option>
        <option value="Full-time">Full-time</option>
        <option value="Part-time">Part-time</option>
        <option value="Contract">Contract</option>
        <option value="Internship">Internship</option>
      </select>

      {/* Update Job Button */}
      <button onClick={handleUpdateJob} className={styles.postButton}>
        Update Job
      </button>
      </div>
      {/* Footer */}
      <div className={styles.footer}>
        <footer>
          <p>&copy;2024 TechServiceMarket Software</p>
        </footer>
      </div>
    </div>
  );
};

export default EditJob;
